import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  fetchNotificationSettingsAsync,
  fetchNotificationTemplatesAsync,
  fetchPharmaciesAsync,
  fetchPrimaryDoctorAsync,
  fetchPrimaryCaregiverAsync,
  fetchSpecialistsAsync,
  handleLoadingState,
  primaryCaregiverSelector,
  savePrimaryCaregiverAsync,
} from '../../../lib/dataLayer';
import { isLoadingSelector } from '../../../store/app/selectors';
import PrimaryCaregiverPage from '../components/PrimaryCaregiverPage';

const mapStateToProps = state => ({
  primaryCaregiver: primaryCaregiverSelector(state),
  isLoading: isLoadingSelector(state),
});

// this gets fired onMount
// those are all necessary for the notifications
const fetchDataAsync = () => dispatch => {
  return dispatch(fetchPrimaryDoctorAsync())
    .then(() => dispatch(fetchNotificationSettingsAsync()))
    .then(() => dispatch(fetchNotificationTemplatesAsync()))
    .then(() => dispatch(fetchPrimaryDoctorAsync()))
    .then(() => dispatch(fetchSpecialistsAsync()))
    .then(() => dispatch(fetchPharmaciesAsync()))
    .then(() => dispatch(fetchPrimaryCaregiverAsync()));
};

const mapDispatchToProps = {
  onMount: () => handleLoadingState(fetchDataAsync),
  onSave: savePrimaryCaregiverAsync,
  onContinue: () => push('/child'),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrimaryCaregiverPage);



// WEBPACK FOOTER //
// ./src/modules/PrimaryCaregiverPage/containers/PrimaryCaregiverPageContainer.js